import React from 'react'

const WhishList = () => {
    return (
        <div>WhishList</div>
    )
}

export default WhishList